module.exports = __webpack_public_path__ + "static/media/Node.js_logo_optimized.56d7cee2.svg";